import React, { useState, useEffect } from 'react';
import AppShell from '../../../components/AppShell';
import { Card, CardContent } from '../../../components/ui/card';
import { Select, SelectItem } from '../../../components/ui/select';
import { Button } from '../../../components/ui/button';
import ToggleSwitch from './components/ToggleSwitch';

export default function ReplyBotSettings() {
  const [tone, setTone] = useState('friendly');
  const [language, setLanguage] = useState('en');
  const [ctaStyle, setCtaStyle] = useState('direct');
  const [autoReplyInstagram, setAutoReplyInstagram] = useState(true);
  const [autoReplyWhatsApp, setAutoReplyWhatsApp] = useState(true);
  const [loading, setLoading] = useState(false);

  // Optional: load existing settings via API here
  useEffect(() => {
    // fetchUserSettings().then(...)
  }, []);

  const handleSave = () => {
    setLoading(true);
    const config = {
      tone,
      language,
      ctaStyle,
      autoReplyInstagram,
      autoReplyWhatsApp,
    };
    // Replace with real API call to save settings
    console.log('Saving config:', config);
    setTimeout(() => setLoading(false), 1000);
  };

  return (
    <AppShell>
        <div className="col-span-12 space-y-12">
      <div className="max-w-3xl mx-auto py-10 px-4 space-y-6">
        <h1 className="text-2xl font-semibold mb-2">ReplyBot Settings</h1>

        <Card>
          <CardContent className="p-6 space-y-4">
            <h2 className="text-lg font-semibold">Brand Voice</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <Select label="Tone" value={tone} onValueChange={setTone}>
                <SelectItem value="friendly">Friendly</SelectItem>
                <SelectItem value="professional">Professional</SelectItem>
                <SelectItem value="fun">Fun</SelectItem>
              </Select>
              <Select label="Language" value={language} onValueChange={setLanguage}>
                <SelectItem value="en">English</SelectItem>
                <SelectItem value="ar">Arabic</SelectItem>
                <SelectItem value="hi">Hindi</SelectItem>
              </Select>
              <Select label="CTA Style" value={ctaStyle} onValueChange={setCtaStyle}>
                <SelectItem value="direct">Direct</SelectItem>
                <SelectItem value="soft">Soft</SelectItem>
                <SelectItem value="promo">Promotional</SelectItem>
              </Select>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-6 space-y-4">
            <h2 className="text-lg font-semibold">Auto-Reply Settings</h2>
            <ToggleSwitch
              label="Enable AI Auto-Reply for Instagram DMs"
              checked={autoReplyInstagram}
              onCheckedChange={setAutoReplyInstagram}
            />
            <ToggleSwitch
              label="Enable AI Auto-Reply for WhatsApp"
              checked={autoReplyWhatsApp}
              onCheckedChange={setAutoReplyWhatsApp}
            />
          </CardContent>
        </Card>

        <Button onClick={handleSave} disabled={loading} className="mt-4">
          {loading ? 'Saving...' : 'Save Settings'}
        </Button>
      </div>
      </div>
    </AppShell>
  );
}
